import { FaTimes } from "react-icons/fa";

interface xProps {
  acao: () => void;
}
export function IconeX({ acao }: xProps) {
  return <FaTimes style={{ cursor: "pointer" }} onClick={acao} />;
}
